<template>
    <div v-show="isActive">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "bs-tab",
        props: {
            name: { required: true },
            selected: { default: false},
            customHref: {required: false}
        },
        data() {
            return {
                isActive: false
            };
        },
        computed: {
            href() {
                if (this.customHref === undefined) {
                    return '#' + this.name.toLowerCase().replace(/ /g, '-');
                } else {
                    return '#' + this.customHref;
                }

            }
        },
        mounted() {
            //this.isActive = this.selected;
            if (window.location.hash.includes('.')) {
                // Remove # and split fragment into tab names (separated by a dot)
                let  tabs = window.location.hash.slice(1, window.location.hash.length).split('.');

                for (let tab in tabs) {
                    if (this.customHref === tabs[tab]) {
                        this.isActive= true;
                    }
                }
            }

            if(window.location.hash === '#'+this.customHref) {
                this.isActive= true;
            }

            if (!window.location.hash) {
                this.isActive = this.selected;
            }
        }
    }
</script>

<style scoped>

</style>